export const baseURL = process.env.REACT_APP_BASE_URL;

export const paginationVal = {
  pageCount: 0,
  pageNumber: 1,
  searchTerm: '',
};

export const sharepointCredentials = {
  clientId: process.env.REACT_APP_SSO_CLIENT_ID,
  authority: process.env.REACT_APP_SSO_AUTHORITY,
  redirectUri: process.env.REACT_APP_SSO_REDIRECT_URI,
  scopes: process.env.REACT_APP_SSO_SCOPES.split(","),
};